import * as types from './mutations-type';

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.

export default {
  [types.SET_LOADING](state, loading) {
    state.loading = loading;
  },
  [types.SET_MESSAGE](state, message) {
    state.message = message;
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js